import { useEffect, useState } from 'react';
import { CLOSE_ICON } from '../../../../assets/icons';
import { Portal } from '../../../../components/Modal';
import GenerateAgreementDocument from './doc';
import { ITutor, ITutorAgreement, ITutorRequest } from '@wot/typings';
import { Button } from '@wot/components';

interface Props {
  onClose: () => void;
  tutor: ITutorRequest | ITutor;
  handleSubmit: (data: ITutorAgreement) => void;
}
export default function Agreement({ onClose, tutor, handleSubmit }: Props) {
  // const [step, setStep] = useState(1);
  const [agreement, setAgreement] = useState<ITutorAgreement>({
    document: tutor.agreement?.document || [],
    joiningDate: tutor.agreement?.joiningDate || '',
    level: tutor.agreement?.level || 'standard',
    offerExpiryDate: tutor.agreement?.offerExpiryDate || '',
    status: 'pending',
    currency: tutor.agreement?.currency || '',
    createdAt: tutor.agreement?.createdAt || '',
    updatedAt: tutor.agreement?.updatedAt || ''
  });
  const [errors, setErrors] = useState({
    joiningDate: false,
    offerExpiryDate: false,
    level: false
  });

  // const onStep1 = () => {
  //   if (!agreement.joiningDate || !agreement.offerExpiryDate) {
  //     setErrors({
  //       ...errors,
  //       joiningDate: !agreement.joiningDate,
  //       offerExpiryDate: !agreement.offerExpiryDate
  //     });
  //     return;
  //   }
  //   setErrors({
  //     ...errors,
  //     joiningDate: false,
  //     offerExpiryDate: false
  //   });
  //   // setStep(2);
  // };

  const onSave = () => {
    if (!agreement.level) {
      setErrors({
        ...errors,
        level: !agreement.level
      });
      return;
    }
    setErrors({
      ...errors,
      level: false
    });

    handleSubmit(agreement);
  };

  useEffect(() => {
    let text = GenerateAgreementDocument(tutor, agreement);
    setAgreement({
      ...agreement,
      document: text
    });
  }, [agreement.joiningDate, agreement.offerExpiryDate, agreement.level, agreement.currency]);

  const handleJoiningDate = (date: Date | null) => {
    if (date) {
      setAgreement({ ...agreement, joiningDate: date.toISOString() });
    }
  };
  const handleOfferExpiryDate = (date: Date | null) => {
    if (date) {
      setAgreement({ ...agreement, offerExpiryDate: date.toISOString() });
    }
  };

  return (
    <Portal>
      <div className="relative w-screen h-screen flex items-end  ">
        <div className="absolute top-0 left-0 w-full h-full bg-black/40 -z-10"></div>

        <div className="w-full h-[90%] bg-gray-50 flex flex-col items-center z-40 overflow-y-auto rounded-t-3xl">
          <div className="relative w-full flex items-center justify-center px-10 py-7 border-b">
            <img onClick={() => onClose()} src={CLOSE_ICON} className="w-4 h-4 cursor-pointer ml-auto" />
            {/* <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 w-full flex items-center justify-center gap-10">
              <div
                onClick={() => setStep(1)}
                className={`w-8 h-8 ${step === 1
                  ? "bg-secondary text-white"
                  : "bg-white text-black"
                  } border p-1 rounded-full flex items-center justify-center cursor-pointer`}
              >
                1
              </div>
              <div
                onClick={() => setStep(2)}
                className={`w-8 h-8 ${step === 2
                  ? "bg-secondary text-white"
                  : "bg-white text-black"
                  } border p-1 rounded-full flex items-center justify-center cursor-pointer`}
              >
                2
              </div>
            </div> */}
          </div>

          <div className="w-4/5 h-full mx-auto my-6 flex flex-col ">
            {/* {step === 1 && ( */}
            <div className="w-full h-full flex gap-10">
              <div className="w-2/5 h-full bg-neutralBlue2 flex flex-col gap-8 rounded-md p-4 px-8">
                <div className="w-full flex flex-col gap-2">
                  <p className="text-sm">Joining Date</p>
                  <input
                    type="date"
                    value={agreement.joiningDate.split('T')[0]}
                    onChange={(e) => handleJoiningDate(e.target.valueAsDate)}
                    className={`w-full text-sm px-3 py-3 placeholder:text-black/40 placeholder:font-light 
         border-2 border-neutralBlue1 outline-none focus:outline-none rounded-md`}
                  />
                  {errors?.joiningDate && (
                    <p className="text-xs font-medium text-red-400">Please Select a Joining Date</p>
                  )}
                </div>
                <div className="w-full flex flex-col gap-2">
                  <p className="text-sm">Offer Expiry Date</p>
                  <input
                    type="date"
                    value={agreement.offerExpiryDate.split('T')[0]}
                    onChange={(e) => handleOfferExpiryDate(e.target.valueAsDate)}
                    className={`w-full text-sm px-3 py-3 placeholder:text-black/40 placeholder:font-light 
         border-2 border-neutralBlue1 outline-none focus:outline-none rounded-md`}
                  />
                  {errors?.offerExpiryDate && (
                    <p className="text-xs font-medium text-red-400">Please Select a Offer Expiry Date</p>
                  )}{' '}
                </div>
              </div>

              <div className="w-3/5 h-full flex max-h-fit overflow-y-scroll flex-col gap-2">
                {agreement.document.map((item, index) => (
                  <div className="flex flex-col gap-4" key={index}>
                    {item.title && <h1>{item.title}</h1>}
                    {item.contents && (
                      <div className="flex flex-col gap-2">
                        {item.contents.map((item, index) => (
                          <p className="text-sm" key={index}>
                            {item}
                          </p>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>

            <div className="w-full max-w-[164px] mx-auto my-4">
              {/* {step === 1 && (
                <Button
                  text="Next"
                  bgColor="bg-secondary"
                  borderColor="border-secondary"
                  textColor="text-white"
                  onClick={() => onStep1()}
                />
              )}
              {step === 2 && ( */}
              <Button text="Save" onClick={() => onSave()} />
              {/* )} */}
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
}

{
  /*step === 2 && (
  <div className="w-full h-full flex gap-10">
    <div className="w-2/5 h-full bg-neutralBlue2 flex flex-col gap-8 rounded-md p-4 px-8">
      <div className="flex items-center">
        <p className="w-2/5 text-sm shrink-0">Level</p>
        <div className="w-full flex flex-col">
          <DropDown
            label="Select Levels"
            value={agreement?.level || ""}
            icon={ARROWDOWN_ICON}
            name="level"
          >
            <DropDownItems
              options={levelOptions}
              setValue={(value: ITutorLevel) => {
                setAgreement({
                  ...agreement,
                  level: value,
                });
              }}
            />
          </DropDown>
          {errors?.level && (
            <p className="text-xs font-medium text-red-400">
              Please Select a Level
            </p>
          )}
        </div>
      </div>
      {/* 
      <div className="flex items-center">
        <p className="w-2/5 text-sm shrink-0">Cost Per Session</p>
        <div className="w-full flex flex-col">
          <div className="flex items-center gap-4">
            <div className="w-full flex flex-col">
              <DropDown
                label="INR"
                value={agreement.currency || "INR"}
                icon={ARROWDOWN_ICON}
                name="currency"
              >
                <DropDownItems options={["INR"]} setValue={(value: string) => {
                  setAgreement({
                    ...agreement,
                    currency: value
                  })
                }} />
              </DropDown>
            </div>
            <input value={agreement.costPerSession} type="number" onChange={(e) => setAgreement({ ...agreement, costPerSession: Number(e.target.value) })}
              className={`w-full text-sm px-3 py-3 placeholder:text-black/40 placeholder:font-light 
border-2 border-neutralBlue1 outline-none focus:outline-none rounded-md`} />
          </div>
          {errors?.costPerSession && (
            <p className="text-xs font-medium text-red-400">
              Please add a cost per session
            </p>
          )}
        </div>
      </div> 
    </div>
    <div className="w-3/5 h-full flex flex-col gap-2">
      {agreement.document.map((item, index) => (
        <div className="flex flex-col gap-4" key={index}>
          {item.title && <h1>{item.title}</h1>}
          {item.contents && (
            <div className="flex flex-col gap-2">
              {item.contents.map((item, index) => (
                <p className="text-sm" key={index}>
                  {item}
                </p>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  </div>
              )}*/
}
